// src/components/error/InlineErrorBanner.jsx
import React from "react";
import { Button } from "reactstrap";

export default function ErrorBanner({
  title,
  description,
  onRetry,
  showRetry = true,
}) {
  return (
    <div className="d-flex flex-column align-items-center mt-4 ">
      {/* Yellow banner */}
      <div className="sub-gray-text"
        style={{
          backgroundColor: "#fff8d5", // soft yellow
          border: "1px solid #ffe7a3",
          borderRadius: "4px",
          padding: "14px 24px",
          maxWidth: "600px",
          textAlign: "center",
          fontSize: "0.95rem",
          color:'black'
        }}
      >
        {title && (
          <h6 className="fw-semibold mb-1" style={{ color:'black'}}>
            {title}
          </h6>
        )}
        <div>{description}</div>
      </div>

      {/* Buttons row */}
      {showRetry && (
        <div className="mt-3 btn-click">
          <Button color="primary" size="sm" onClick={onRetry}>
            Retry
          </Button>
        </div>
      )}
    </div>
  );
}
